import { APIS } from '@/constants';
import axios from 'axios';

const approvalStateApi = {
  /**
   *
   * @param {String} token
   * @returns {AxiosPromise}
   */
  requestAll(token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: '/all',
      method: 'get',
      baseURL: APIS.BASE_URL.APPROVAL_STATE,
      headers,
    });
  },
};

export default approvalStateApi;
